import type { CSSProperties, ReactNode } from 'react';

export interface FormFieldProps {
    label?: ReactNode;
    /** Texto de apoio. Some quando há `error`. */
    hint?: ReactNode;
    error?: ReactNode;
    required?: boolean;
    /** `id` do controle. Sem ele o rótulo não fica associado. */
    htmlFor?: string;
    children?: ReactNode;
    style?: CSSProperties;
}

export function FormField({ label, hint, error, required = false, htmlFor, children, style }: FormFieldProps) {
    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 6, minWidth: 0, ...style }}>
            {label && (
                <label htmlFor={htmlFor} style={{ fontFamily: 'var(--font-ui)', fontSize: 13, lineHeight: '18px', fontWeight: 500, color: 'var(--neutral-700)' }}>
                    {label}
                    {required && <span style={{ color: 'var(--danger)', marginLeft: 3 }}>*</span>}
                </label>
            )}
            {children}
            {error ? (
                <span style={{ fontSize: 12, lineHeight: '16px', color: 'var(--danger-strong)', display: 'flex', alignItems: 'center', gap: 5 }}>{error}</span>
            ) : hint ? (
                <span style={{ fontSize: 12, lineHeight: '16px', color: 'var(--text-tertiary)' }}>{hint}</span>
            ) : null}
        </div>
    );
}
